// src/components/admin/page-management/SectionPreview.js
import React from 'react';

const SectionPreview = ({ section }) => {
  const { type, content } = section;

  // Different preview based on section type
  const renderPreview = () => {
    switch (type) {
      case 'hero':
        return (
          <div>
            <p><strong>Title:</strong> {content?.title || 'None'}</p>
            <p><strong>Subtitle:</strong> {content?.subtitle || 'None'}</p>
            {content?.imageUrl && <p><strong>Has Image:</strong> Yes</p>}
            {content?.buttonText && <p><strong>Button:</strong> {content.buttonText}</p>}
          </div>
        );

      case 'headerDivided':
        return (
          <div>
            <p><strong>Split Header:</strong> {content?.title?.substring(0, 30) || 'No title'}...</p>
            <p><strong>With Image:</strong> {content?.mainImage ? 'Yes' : 'No'}</p>
            {content?.primaryButtonText && <p><strong>Primary Button:</strong> {content.primaryButtonText}</p>}
          </div>
        );
        
      case 'text':
        return (
          <div>
            <p><strong>Title:</strong> {content?.title || 'None'}</p>
            <p><strong>Text:</strong> {content?.text?.substring(0, 100)}{content?.text?.length > 100 ? '...' : ''}</p>
          </div>
        );
        
      case 'richText':
        return (
          <p><strong>Rich Text Content:</strong> {content?.richText?.length || 0} characters</p>
        );
        
      case 'button':
        return (
          <div>
            <p><strong>Text:</strong> {content?.buttonText || 'None'}</p>
            <p><strong>Link:</strong> {content?.buttonLink || 'None'}</p>
            <p><strong>Style:</strong> {content?.buttonStyle || 'primary'}</p>
          </div>
        );
        
      case 'image':
        return (
          <div>
            <p><strong>Image URL:</strong> {content?.imageUrl ? 'Set' : 'None'}</p>
            <p><strong>Alt Text:</strong> {content?.imageAlt || 'None'}</p>
          </div>
        );
        
      case 'gallery':
        return (
          <p><strong>Images:</strong> {content?.images?.length || 0}</p>
        );
        
      case 'cta':
        return (
          <div>
            <p><strong>Title:</strong> {content?.ctaTitle || 'None'}</p>
            <p><strong>Button:</strong> {content?.ctaButtonText || 'None'}</p>
          </div>
        );
        
      case 'columns':
        return (
          <p><strong>Columns:</strong> {content?.columns?.length || 0}</p>
        );
        
      case 'spacer':
        return (
          <p><strong>Height:</strong> {content?.spacerHeight || '2rem'}</p>
        );
        
      case 'container':
        return (
          <div>
            <p><strong>Container Type:</strong> {content?.containerType || 'standard'}</p>
            {content?.padding && <p><strong>Padding:</strong> {content.padding}</p>}
          </div>
        );
        
      case 'slideshow':
        return (
          <div>
            <p><strong>Slides:</strong> {content?.slides?.length || 0}</p>
            <p><strong>Height:</strong> {content?.height || '800px'}</p>
            {content?.buttonText && <p><strong>Button:</strong> {content.buttonText}</p>}
          </div>
        );
      case 'slideshowHeaderWave':
        return (
          <div>
            <p><strong>Slideshow Home Wave Banner:</strong> {content?.title || 'No title'}</p>
            <p><strong>Buttons:</strong> {content?.primaryButtonText || 'None'} {content?.secondaryButtonText ? `/ ${content?.secondaryButtonText}` : ''}</p>
          </div>
        );          
      case 'slideshowLinear':
        return (
          <div>
            <p><strong>Slides:</strong> {content?.slides?.length || 0}</p>
            <p><strong>Height:</strong> {content?.height || '800px'}</p>
            {content?.buttonText && <p><strong>Button:</strong> {content.buttonText}</p>}
          </div>
        );

      case 'teamMembers':
        return (
          <div>
            <p><strong>Title:</strong> {content?.sectionTitle || 'Team Members'}</p>
            <p><strong>Layout:</strong> {content?.layout || 'Grid'}</p>
            {content?.department && <p><strong>Department:</strong> {content.department}</p>}
            {content?.showLeadershipOnly && <p><strong>Leadership Only:</strong> Yes</p>}
          </div>
        );  
      case 'productCatalog':
        return (
          <div>
            <p style={{color:'red'}}><strong>Please note that you can have only 1 of this section in your whole website<br/>
              If you add more in different pages, your website will throws error in /cat/..</strong></p>
            <p><strong>Category Catalog linear:</strong> {content?.title || 'Products'}</p>
            <p><strong>Layout:</strong> {content?.productsPerRow || 3} products per row</p>
            {content?.showSearch !== false && <p><strong>Search:</strong> Enabled</p>}
          </div>
        );    
  
      case 'productCatalogVertical':
        return (
          <div>
            <p><strong>Category Catalog vertical:</strong> {content?.title || 'Browse Categories'}</p>
            <p><strong>Layout:</strong> {content?.layoutType === 'slider' ? 'Slider' : 'Vertical'}</p>
          </div>
        );
        
      case 'staticContent':
        return (
          <div>
            <p><strong>Static Content:</strong> {content?.title || 'No title'}</p>
            <p><strong>Has Image:</strong> {content?.imageUrl ? 'Yes' : 'No'}</p>
            <p><strong>Has Button:</strong> {content?.buttonText ? 'Yes' : 'No'}</p>
          </div>
        );
        
      case 'featuredProducts':
        return (
          <div>
            <p><strong>Featured Products:</strong> {content?.title || 'Featured Products'}</p>
            <p><strong>Count:</strong> {content?.maxProducts || 5} products</p>
          </div>
        );
        
      case 'statistics':
        return (
          <div>
            <p><strong>Statistics Section</strong></p>
            <p><strong>Stats:</strong> {(content?.statistics || []).length} items</p>
          </div>
        );
        
      case 'blogPosts':
        return (
          <div>
            <p><strong>Blog Posts:</strong> {content?.title || 'Latest From Our Blog'}</p>
            <p><strong>Posts:</strong> {content?.postsCount || 3} posts</p>
          </div>
        );

      case 'features':
        return (
          <div>
            <p><strong>Features Section:</strong> {content?.title || 'Why Choose Bag & Box?'}</p>
            <p><strong>Features Count:</strong> {(content?.features || []).length}</p>
          </div>
        );
            
      case 'newsletter':
        return (
          <div>
            <p><strong>Newsletter:</strong> {content?.title || 'Join Our Newsletter'}</p>
            <p><strong>Button:</strong> {content?.buttonText || 'Subscribe'}</p>
          </div>
        );
            
      case 'testimonials':
        return (
          <div>
            <p><strong>Testimonials:</strong> {content?.title || 'What Our Clients Say'}</p>
            <p><strong>Count:</strong> {(content?.testimonials || []).length} testimonials</p>
            <p><strong>Layout:</strong> {content?.layout || 'grid'}</p>
          </div>
        );

      case 'contactForm':
        return (
          <div>
            <p><strong>Contact Form:</strong> {content?.title || 'Send Us a Message'}</p>
            <p><strong>Show Contact Info:</strong> {content?.showContactInfo !== false ? 'Yes' : 'No'}</p>
          </div>
        );
        
      case 'googleMaps':
        return (
          <div>
            <p><strong>Map Address:</strong> {content?.address ? (content.address.substring(0, 30) + '...') : 'Default'}</p>
            <p><strong>Map Height:</strong> {content?.height || '400px'}</p>
          </div>
        );
  
        
      default:
        return <p>Unknown section type: {type}</p>;
    }
  };

  return (
    <div className="text-sm">
      {renderPreview()}
      {content?.backgroundColor && (
        <p><strong>Background Color:</strong> {content.backgroundColor}</p>
      )}
      {section.settings?.fullWidth && (
        <p><strong>Full Width:</strong> Yes</p>
      )}
    </div>
  );
};

export default SectionPreview;